import React from 'react';
import { useTranslation } from 'next-i18next';
import { ErrorBoundaryFallback } from '@/components';
import { MagnifyingGlassIcon } from '@/icons';
import { useFetchCategoryInfoByCountryCode } from '@/module/public/hooks/useFetchCategoryInfo';
import { useCreateSubjectNameGetter } from '@/shared/category/useCreateSubjectNameGetter';
import { filterExternalPlatformQuizzes, useExternalPlatform } from '@/shared/externalPlatform';
import { EmptyQuizList } from '@/shared/quizList/EmptyQuizList';
import { useGetQuizListItemButtons } from '@/shared/quizList/hooks/useGetQuizListItemButtons';
import { InfiniteListView } from '@/shared/quizList/InfiniteListView';
import { QuizListItem } from '@/shared/quizList/QuizListItem';
import { useUserQuizes } from './hooks/useFetchUserQuizes';
export const UserQuizList = (props: {
  countryCode: string;
  userHashId: string;
  userEmail: string;
  username: string;
}) => {
  const {
    flatData,
    isLoading,
    isError,
    hasNextPage,
    fetchNextPage
  } = useUserQuizes(props.userHashId);
  const {
    t
  } = useTranslation(['common']);
  const {
    categoryTreeData
  } = useFetchCategoryInfoByCountryCode(props.countryCode);
  const getQuizButtons = useGetQuizListItemButtons('user');
  const {
    mode
  } = useExternalPlatform();
  const subjectNameGetter = useCreateSubjectNameGetter(categoryTreeData?.subjectTree);
  const visibleQuizzes = filterExternalPlatformQuizzes(flatData, mode);
  return <InfiniteListView items={visibleQuizzes} isLoading={isLoading} isError={isError} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} renderItem={quiz => <QuizListItem eventLocation={'user'} eventAdditionalProperty={{
    user: {
      userEmail: props.userEmail,
      username: props.username
    }
  }} key={quiz.id} isHideAuthor={true} alwaysDropDownMenu={false} subjectName={subjectNameGetter({
    subjectGroupId: quiz.categoryInfo?.subject,
    subSubjectGroupId: quiz.categoryInfo?.subSubject
  })} menuItems={getQuizButtons(quiz)} quizSet={quiz} />} EmptyComponent={<EmptyQuizList title={t('common:quizList.empty.publicQuiz')} description={t('common:quizList.empty.otherUserQuiz')} goToActionInfo={{
    icon: MagnifyingGlassIcon,
    label: t('common.quizExplore'),
    href: '/public',
    target: '_blank'
  }} type={'myQuiz'} />} ErrorComponent={<ErrorBoundaryFallback />} LoadingComponent={null} data-sentry-element="InfiniteListView" data-sentry-component="UserQuizList" data-sentry-source-file="UserQuizList.tsx" />;
};